import { Reducer } from 'redux';
import {
    USER_DELETE_START,
    USER_DELETE_SUCCESS,
    USER_ERROR,
    USER_CLEAR_ERROR,
    USER_CLEAR_SUCCESS,
    USER_FETCH_START,
    USER_FETCH_SUCCESS,
    USER_RESET,
    USER_SAVE_START,
    USER_SAVE_SUCCESS,
    UserAction
} from 'actions/user/UserActionsTypes';
import { UsersState, UserStatus } from './UsersState';

const initialState: UsersState = {
    users: [],
    pagination: {
        currentPage: 1,
        prevPage: null,
        nextPage: null,
        size: 10,
        totalPages: 0,
        totalRecords: 0
    },
    status: UserStatus.Initial,
    loading: false
};

export const usersReducer: Reducer<UsersState, UserAction> = (state = initialState, action) => {
    switch (action.type) {
        case USER_RESET:
            return {
                ...initialState
            };

        case USER_ERROR:
            return {
                ...state,
                loading: false,
                status: UserStatus.Error,
                error: action.payload.error
            };

        case USER_CLEAR_ERROR:
            return {
                ...state,
                status: UserStatus.Initial,
                error: undefined
            };

        case USER_CLEAR_SUCCESS:
            return {
                ...state,
                status: UserStatus.Initial,
                savedUser: undefined
            };

        case USER_FETCH_START:
            return {
                ...state,
                loading: true,
                status: UserStatus.Fetching,
                error: undefined // Clear previous errors
            };

        case USER_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                status: UserStatus.FetchSuccess,
                // Always replace data for pagination (not infinite scroll)
                users: action.payload.users,
                pagination: action.payload.pagination
            };

        case USER_SAVE_START:
            return {
                ...state,
                loading: true,
                status: UserStatus.Saving,
                savedUser: undefined,
                error: undefined // Clear previous errors
            };

        case USER_SAVE_SUCCESS:
            let users = [...state.users];

            if (users.some(u => u.id === action.payload.user.id)) {
                users = users.map(u => (u.id === action.payload.user.id ? { ...action.payload.user } : u));
            } else {
                users = [...users, { ...action.payload.user }];
            }

            // Sort by name (last_name, then first_name)
            const sortedUsers = users.sort((a, b) => {
                const nameA = `${a.lastName || ''} ${a.firstName || ''}`.trim();
                const nameB = `${b.lastName || ''} ${b.firstName || ''}`.trim();
                return nameA.localeCompare(nameB);
            });

            return {
                ...state,
                loading: false,
                status: UserStatus.SaveSuccess,
                users: sortedUsers,
                savedUser: { ...action.payload.user }
            };

        case USER_DELETE_START:
            return {
                ...state,
                loading: true,
                status: UserStatus.Deleting
            };

        case USER_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: UserStatus.DeleteSuccess,
                users: state.users.filter(u => u.id !== action.payload.userId)
            };

        default:
            return state;
    }
};

export default usersReducer;
